import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getFinancialHistoryUserInfo } from 'services/financialHistory'
import posthog from 'posthog-js'

export default function useGetUserInfo() {
    const { moneyPool, poolship } = useParams()
    const { data, isLoading } = useQuery(
        ['financial-history-user-info', moneyPool, poolship],
        getFinancialHistoryUserInfo,
        {
            onError: (error: any) => {
                posthog.capture('member_detail_load_failed', {
                    fund_id: moneyPool,
                    poolship_id: poolship,
                    status: error?.response?.status,
                })
            },
        }
    )
    return { userInfo: data, isLoadingUserInfo: isLoading }
}
